import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import { database } from '../../utils/firebase';

const PayoutsReport = () => {
    const { leagueId, startDate, endDate, print, header } = useParams();
    const [matches, setMatches] = useState([]);
    const [players, setPlayers] = useState([]);
    const [leagueSettings, setLeagueSettings] = useState({});
    const [payouts, setPayouts] = useState({});
    const [leagueData, setLeagueData] = useState({});

    useEffect(() => {
        const leagueRef = ref(database, `leagues/${leagueId}`);
        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            console.log('Fetched league data:', data);
            if (data) {
                setLeagueData(data);
                setLeagueSettings(data.settings || {});
                const playersArray = Object.entries(data.players || {}).map(([id, player]) => ({ id, ...player }));
                setPlayers(playersArray); // Ensure players is an array with IDs
                const allMatches = Object.entries(data.matches || {}).map(([id, match]) => ({ id, ...match }));
                console.log('All matches:', allMatches);
                const filteredMatches = allMatches.filter(match => {
                    const start = parseInt(startDate, 10);
                    const end = parseInt(endDate, 10);
                    return start <= match.dateTime && match.dateTime <= end;
                });
                console.log('Filtered matches:', filteredMatches);
                setMatches(filteredMatches);

                const playerPayouts = {};
                filteredMatches.forEach(match => {
                    Object.entries(match.scores || {}).forEach(([playerId, score]) => {
                        if (!playerPayouts[playerId]) {
                            playerPayouts[playerId] = {};
                        }
                        playerPayouts[playerId][match.id] = score.payouts?.total || 0;
                    });
                });
                console.log('Player payouts:', playerPayouts);
                setPayouts(playerPayouts);
            } else {
                console.error('No data found for the given leagueId.');
            }
            if (print === 'true') {
                setTimeout(() => {
                    window.print();
                }, 100);
            }
        }, (error) => {
            console.error('Error fetching league data from Firebase:', error);
        });
    }, [leagueId, startDate, endDate]);

    const formatDate = (timestamp, type) => {
        const options = type === "short"
            ? { month: 'short', day: 'numeric' }
            : { month: 'short', day: 'numeric', year: 'numeric' };
        return new Date(timestamp * 1000).toLocaleDateString(leagueSettings.language, options);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    };

    const calculateTotal = (playerId) => {
        return matches.reduce((total, match) => {
            return total + (payouts[playerId]?.[match.id] || 0);
        }, 0);
    };

    const calculateMatchTotal = (matchId) => {
        return players.reduce((total, player) => {
            return total + (payouts[player.id]?.[matchId] || 0);
        }, 0);
    };

    const sortedPlayers = [...players].sort((a, b) => {
        const lastNameA = a.name.split(' ').slice(-1)[0];
        const lastNameB = b.name.split(' ').slice(-1)[0];
        return lastNameA.localeCompare(lastNameB);
    });

    return (
        <div style={{backgroundColor: '#ffffff'}}>
            <div className={'modern-report report-container'}>
                <div className="modern-report-container">
                    {header === 'true' && (
                        <div className={'modern-report-header'}>
                            <h1>Payouts Report</h1>
                            <h3>{leagueData.name}</h3>
                            <h4>{leagueData.parentGroup}</h4>
                            <h4>{`${formatDate(startDate, "long")} - ${formatDate(endDate, "long")}`}</h4>
                        </div>
                    )}
                    <table>
                        <thead>
                            <tr>
                                <th width={'30%'}>Player Name</th>
                                {matches
                                    .sort((a, b) => a.dateTime - b.dateTime) // Sort matches by dateTime
                                    .map((match, index) => (
                                        <th key={index}>{formatDate(match.dateTime, "short")}</th>
                                    ))}
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                        {sortedPlayers
                            .sort((a, b) => a.dateTime - b.dateTime) // Sort matches by dateTime
                            .map((player, index) => (
                            <tr key={index}>
                                <td>{player.name}</td>
                                {matches.map((match, matchIndex) => {
                                    console.log(player.id);
                                    const payout = payouts[player.id]?.[match.id] || 0;
                                    return (
                                        <td key={matchIndex}>{payout !== 0 ? formatCurrency(payout) : ''}</td>
                                    );
                                })}
                                <td>{formatCurrency(calculateTotal(player.id))}</td>
                            </tr>
                        ))}


                        <tr>
                            <td>Total</td>
                            {matches
                                .sort((a, b) => a.dateTime - b.dateTime) // Sort matches by dateTime
                                .map((match, matchIndex) => (
                                <td key={matchIndex}>{formatCurrency(calculateMatchTotal(match.id))}</td>
                            ))}
                            <td>{formatCurrency(players.reduce((total, player) => total + calculateTotal(player.id), 0))}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PayoutsReport;